import React from 'react'
import { useSelector } from "react-redux";
import * as CONST from '../../../app/constants'
import { currentAgentApplicationSelector } from '../../../redux/selector/collectorApplicationSelector';
import { EducationCertificate } from '../common/EducationCertificate'
import { fullName } from "../../../app/utils";

export const MraRenewalBrokerEducationCertificate = (props) => {
    const agentApplication = useSelector(currentAgentApplicationSelector);
    const buttonTitle = props.isModal ? '"Save and close"' : '"Continue"'

    let agentName, text2, text3;
    if(agentApplication?.businessLicenceData && agentApplication?.licencingSubType !== CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION) {
        agentName = fullName(agentApplication?.businessLicenceData?.personData);
        text2 = `If ${agentName} needs to submit their proof of education, upload their education certificate from MPC.`;
        text3 = `If ${agentName} does not need to provide proof of education, hit ${buttonTitle}.`;
    }
    else {
        text2 = "If you need to submit your proof of education, upload your education certificate from MPC.";
        text3 = `If you do not need to provide proof of education, hit ${buttonTitle}.`;
    }

    const applicationMode = CONST.APPLICATION_MODE_RENEW
    const titleText = "Mortgage Broker Education"
    
    const paragraphText = [
        "A requirement for Mortgage Broker licence is the completion of Nova Scotia Mortgage Broker Education Program from Mortgage Professionals Canada (if you are not exempt).",
        text2,
        text3
    ]

    return <EducationCertificate
                {...props}
                applicationMode={applicationMode} 
                titleText={titleText} 
                paragraphText={paragraphText}  
                nextScreenRoute={CONST.ROUTE_PATH.MRA_RENEWAL_PRINCIPAL_BROKER_ACT_REGULATION_CONFIRMATION}
            />
}